$(function() {
  // Q&Aアコーディオンの開閉（ぬるっと開く）
  $(document).on('click', '.js-faq-toggle', function() {
    const $item = $(this).closest('.js-faq-item');
    $item.toggleClass('is-open');
    $(this).attr('aria-expanded', $item.hasClass('is-open'));
    $item.find('.js-faq-answer').stop(true, true).slideToggle(300);
  });

  // カテゴリナビからのページ内スムーススクロール
  $(document).on('click', '.js-faq-anchor', function(e) {
    const href = $(this).attr('href');
    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });
    history.pushState(null, '', href);
  });
});
